import { Route } from '@angular/router';
import { workflowVariablesRoutes } from '../pages/admin-flow/workflow/workflow-variables/workflow-variables.routes';
import {
  ADMIN_ROUTES,
  canDeactivateGuard,
  FEATURE_FLAG_KEY,
  FEATURE_FLAGS,
  pathAllowedByFeatureFlagGuard,
  singleVariableRoutes,
  workflowBuilderRedirectGuard,
} from '@kuiper/ibusiness-core';

export const adminRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ADMIN_ROUTES.LOGS,
  },
  {
    path: ADMIN_ROUTES.DEPARTMENTS.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.DepartmentsComponent;
    },
  },
  {
    path: ADMIN_ROUTES.DEPARTMENTS.FORM,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.DepartmentFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.DEPARTMENTS.DETAILS}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.DepartmentDetailsComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.DEPARTMENTS.FORM}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.DepartmentFormComponent;
    },
  },

  {
    path: ADMIN_ROUTES.USERS_DATABASE.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.UsersDatabaseListComponent;
    },
  },
  {
    path: ADMIN_ROUTES.USERS_DATABASE.FORM,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.UserFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.USERS_DATABASE.DETAILS}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.UserDetailsComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.USERS_DATABASE.FORM}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.UserFormComponent;
    },
  },
  {
    path: ADMIN_ROUTES.ADMINS,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.AdminsListComponent;
    },
  },
  {
    path: ADMIN_ROUTES.GROUPS.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.GroupListComponent;
    },
  },
  {
    path: ADMIN_ROUTES.GROUPS.FORM,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.GroupFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.GROUPS.FORM}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.GroupFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.GROUPS.DETAILS}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.GroupDetailsComponent;
    },
  },
  {
    path: ADMIN_ROUTES.PROJECTS.VARIABLES,
    canDeactivate: [canDeactivateGuard],
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/projects/project-variable/project-variable.component');
      return c.ProjectVariableComponent;
    },
  },
  {
    path: ADMIN_ROUTES.JOB_TITLES.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.JobTitleListComponent;
    },
  },
  {
    path: ADMIN_ROUTES.JOB_TITLES.FORM,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.JobTitleFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.JOB_TITLES.FORM}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.JobTitleFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.JOB_TITLES.DETAILS}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.JobTitleDetailsComponent;
    },
  },
  {
    path: ADMIN_ROUTES.POSITIONS.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.PositionListComponent;
    },
  },
  {
    path: ADMIN_ROUTES.POSITIONS.FORM,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.PositionFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.POSITIONS.FORM}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.PositionFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.POSITIONS.DETAILS}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.PositionDetailsComponent;
    },
  },
  {
    path: ADMIN_ROUTES.PROJECTS.PERMISSIONS.LIST,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/projects/project-permission/project-permission-list/project-permission-list.component');
      return c.ProjectPermissionListComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.PROJECTS.PERMISSIONS.DETAILS}/:mode/:project_id`,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/projects/project-permission/project-permission-details/project-permission-details.component');
      return c.ProjectPermissionDetailsComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.PROJECTS.PERMISSIONS.DETAILS}/:mode/:project_id/:member_id`,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/projects/project-permission/project-permission-details/project-permission-details.component');
      return c.ProjectPermissionDetailsComponent;
    },
  },
  {
    path: ADMIN_ROUTES.PROJECTS.OWNER_TYPE.LIST,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/projects/projects-owner-type/projects-owner-type-list/projects-owner-type/projects-owner-type-list.component');
      return c.ProjectsOwnerTypeListComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.PROJECTS.OWNER_TYPE.PERMISSION_DETAILS}/:id`,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/projects/projects-owner-type/projects-owner-type-details/projects-owner-type-details.component');
      return c.ProjectsOwnerTypeDetailsComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.PROJECTS.OWNER_TYPE.PERMISSION_DETAILS}/:id/:mode`,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/projects/projects-owner-type/projects-owner-type-details/projects-owner-type-details.component');
      return c.ProjectsOwnerTypeDetailsComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.PROJECTS.OWNER_TYPE.PERMISSION_DETAILS}/:id/:mode/:owner_id`,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/projects/projects-owner-type/projects-owner-type-details/projects-owner-type-details.component');
      return c.ProjectsOwnerTypeDetailsComponent;
    },
  },
  {
    path: ADMIN_ROUTES.WORKFLOW.PERMISSIONS.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.WorkflowPermissionListComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.WORKFLOW.PERMISSIONS.DETAILS}/:permission_id/:mode`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.WorkflowPermissionDetailsComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.WORKFLOW.PERMISSIONS.DETAILS}/:permission_id/:mode/:member_id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.WorkflowPermissionDetailsComponent;
    },
  },
  {
    path: ADMIN_ROUTES.WORKFLOW.OWNER_CATEGORY.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.WorkflowOwnersCategoryListComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.WORKFLOW.OWNER_CATEGORY.PERMISSION_DETAILS}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.WorkflowCategoryDetailsComponent;
    },
  },
  {
    path: ADMIN_ROUTES.WORKFLOW.CONFIGURATIONS,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.WorkflowConfigurationComponent;
    },
  },
  {
    path: ADMIN_ROUTES.WORKFLOW.DETAILS_TABLE_ADD_MEMBER,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.WorkflowDetailsTableAddMemberComponent;
    },
  },
  {
    // Redirects to the canvas when the workflow-builder flag is on; the guard returns a
    // UrlTree instead of using `redirectTo` because `redirectTo` + `canMatch` together throw
    // NG04014 (redirects are resolved before guards run).
    path: `${ADMIN_ROUTES.WORKFLOW.CONFIGURATIONS}/:workflowId`,
    canMatch: [workflowBuilderRedirectGuard],
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.WorkflowConfigurationDetailsComponent;
    },
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: '',
    canActivateChild: [pathAllowedByFeatureFlagGuard],
    data: {
      [FEATURE_FLAG_KEY]: FEATURE_FLAGS.WORKFLOW_CONFIGURATION.workflow_builder,
    },
    children: [
      {
        path: ADMIN_ROUTES.WORKFLOW.CUSTOM_WORKFLOWS,
        pathMatch: 'full',
        redirectTo: ADMIN_ROUTES.WORKFLOW.CONFIGURATIONS,
      },
      {
        path: `${ADMIN_ROUTES.WORKFLOW.CUSTOM_WORKFLOWS}/:id`,
        async loadComponent() {
          const c = await import('@kuiper/ibusiness-core');
          return c.CustomWorkflowDetailComponent;
        },
      },
    ],
  },
  {
    path: ADMIN_ROUTES.PROJECTS.DETAILS_TABLE_ADD_MEMBER,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/projects/project-permission/project-permission-details/project-details-table-add-member/project-details-table-add-member.component');
      return c.ProjectDetailsTableAddMemberComponent;
    },
  },
  {
    path: '',
    canActivateChild: [pathAllowedByFeatureFlagGuard],
    data: { [FEATURE_FLAG_KEY]: FEATURE_FLAGS.ADMIN.plan_subscriptions },
    children: [
      {
        path: ADMIN_ROUTES.PLAN_USAGE,
        async loadComponent() {
          const c = await import('@kuiper/ibusiness-core');
          return c.PlanUsageComponent;
        },
      },
    ],
  },
  {
    path: `${ADMIN_ROUTES.SYSTEM_SETTINGS.PROFILE}/:mode`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.SystemSettingsComponent;
    },
  },
  {
    path: ADMIN_ROUTES.USERS_DATABASE.VARIABLES,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.UserManagementVariableComponent;
    },
  },
  ...workflowVariablesRoutes,
  ...singleVariableRoutes,
  {
    path: ADMIN_ROUTES.VENDOR_PERMISSIONS.LIST,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/vendor-permission/vendor-permission.component');
      return c.VendorPermissionComponent;
    },
  },
  {
    path: ADMIN_ROUTES.VENDOR_PERMISSIONS.ADD,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/vendor-permission/vendor-permission-table-form/vendor-permission-table-form.component');
      return c.VendorPermissionTableFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.VENDOR_PERMISSIONS.EDIT}/:id`,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/vendor-permission/vendor-permission-table-form/vendor-permission-table-form.component');
      return c.VendorPermissionTableFormComponent;
    },
  },
  {
    path: ADMIN_ROUTES.INVOICES_PERMISSIONS.LIST,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/invoices-permission/invoices-permission.component');
      return c.InvoicesPermissionComponent;
    },
  },
  {
    path: ADMIN_ROUTES.INVOICES_PERMISSIONS.ADD,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/invoices-permission/invoices-permission-table-form/invoices-permission-table-form.component');
      return c.InvoicesPermissionTableFormComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.INVOICES_PERMISSIONS.EDIT}/:id`,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/invoices-permission/invoices-permission-table-form/invoices-permission-table-form.component');
      return c.InvoicesPermissionTableFormComponent;
    },
  },
  {
    path: ADMIN_ROUTES.SUPER_MANAGERS,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.SuperManagerListComponent;
    },
  },
  {
    path: ADMIN_ROUTES.LOGS,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.LogsListComponent;
    },
  },
  {
    path: ADMIN_ROUTES.VENDOR_DATABASE.LIST,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/vendor-database/vendor-list/vendor-list.component');
      return c.VendorDatabaseListComponent;
    },
  },
  {
    path: `${ADMIN_ROUTES.VENDOR_DATABASE.DETAILS}/:id`,
    async loadComponent() {
      const c =
        await import('../pages/admin-flow/vendor-database/vendor-details/vendor-details.component');
      return c.VendorDetailsComponent;
    },
  },
];
